<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { Header } from './layout/components'

export default {
  components: {
    Header
  },
  data() {
    return {
      lang: 'zh'
    }
  },
  created() {
    // this.autoLang();
    // console.log('自动语言')
    let geturl = window.location.href;
    if (geturl.indexOf('?') >= 0) {
      let params = geturl.split('?')[1]
      let searchParams = new URLSearchParams('?' + params)
      var lang = searchParams.get('lang')
      if (lang) {
        if (lang.indexOf('-') > 0) {
          lang = lang.replaceAll('-', '_');
        }
        console.log('lang', lang)
        if (lang.indexOf('en') >= 0) {
          this.lang = 'en';
        } else if (lang.indexOf('zh_CN') >= 0) {
          this.lang = 'zh-CN';
        } else if (lang.indexOf('ja') >= 0) {
          this.lang = 'ja';
        } else if (lang.indexOf('zh_TW') >= 0) {
          this.lang = 'zh-TW';
        }
        this.$i18n.locale = this.lang;
        window.localStorage.setItem("lang", lang);
      } else {
        this.autoLang();
        console.log('自动语言')
      }
    }
  },
  mounted() {

  },
  methods: {
    //初始化语言信息
    autoLang() {
      //先从换从中获取语言
      let lang = window.localStorage.getItem("lang");
      if (lang) {
        this.$i18n.locale = lang;
      } else {
        //如果获取不到，则根据浏览器语言设置
        switch (navigator.language) {
          case "zh-CN":
            this.$i18n.locale = "zh-CN";
            window.localStorage.setItem("lang", "zh-CN");
            break;
          case "zh-TW":
            this.$i18n.locale = "zh-TW";
            window.localStorage.setItem("lang", "zh-TW");
            break;
          case "en":
            this.$i18n.locale = "en";
            window.localStorage.setItem("lang", "en");
            break;
          case "ja":
            this.$i18n.locale = "ja";
            window.localStorage.setItem("lang", "ja");
            break;
          default:
            this.$i18n.locale = "en";
            window.localStorage.setItem("lang", "en");
            break;
        }
      }
    }
  },

}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  margin: 0;
  height: 100vh;
  font-family: "SimHei";
}

/* @font-face {
  font-family: "kuzhankuaile";
  src: url("../src//assets/font/站酷快乐体.ttf");
} */

@font-face {
  font-family: "youshebiaoti";
  src: url("../src//assets/font/优设标题黑.ttf");
}
</style>
